import { Component, ElementRef, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormmMsgComponent } from '../formm-msg/formm-msg.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastNotificationService } from '../../servicios/toast-notification.service';
import { Router } from '@angular/router';
import { AtributosService } from '../../servicios/atributos.service';
import { AppUtilService } from '../../servicios/app.util.service';
import { HashKeyServices } from '../../servicios/app.hashkey.services';
import { FormBuilder, FormGroup } from '@angular/forms';
import { nkServices } from '../../servicios/app.nkservicios.services';
import { FormPasarelaComponent } from '../form-pasarela/form-pasarela.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-form-test',
  templateUrl: './form-test.component.html',
  styleUrls: ['./form-test.component.css']
})
export class FormTestComponent implements OnInit {
  @ViewChild('minutes', { static: true }) minutes: ElementRef;
  @ViewChild('seconds', { static: true }) seconds: ElementRef;
  secon: any = 59;
  min: any = 3;
  termino:any;
  membresia:any;
  pasarela:any = [];
  b_m:any;
  i_m:any;
  p_m:any;
  constructor(
            private render:Renderer2,
            private servicio:nkServices,
            private fb:FormBuilder,
            private dialog: MatDialog,
            private hashkey:HashKeyServices,
            private util:AppUtilService,
            private atrb:AtributosService,
            private router:Router,
            private notifi:ToastNotificationService,
            private dialogRef: MatDialogRef<FormTestComponent>,
      ///en el injectable llega la informacion del metodo padre en data
      @Inject(MAT_DIALOG_DATA) private data: any
  ) { 
    console.log(data, 'primero');
    this.termino = data.termino;
  }

 async ngOnInit(){
    await this.getParametrosApp();
  }
  async getParametrosApp(){
    try {
      this.pasarela = [];
      /* await  this.srvc.consultar_sesionhttp(null).toPromise(); */
      let valor = {
        termino: await this.atrb.OPER.toUpperCase(),
        cod_rol: await this.atrb.ROL_USUARIOS.cod_rol,
        cod_app : await this.hashkey.encrypt(environment.path_token),
        cod_empresa : await localStorage.getItem('cod_empresa'),
        api: await this.hashkey.encrypt(await this.atrb.API_REST.listarParametroAplicaciones)
      }
      const response = await this.servicio.ApiResthttp(valor).toPromise();
      let img_val;
      let tm_val;
      for (const i in response) {
        img_val = response[i].constante_app.split('_');
        if (img_val[0].toUpperCase() === await this.atrb.PRC.toUpperCase()) {
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.PRC_MMBRS.toUpperCase()) {
           this.membresia = response[i].val_cat;
          }
          if (response[i].constante_app.toUpperCase() === await this.atrb.CONSTANTES_APLICACIONES.PRC_PAY.toUpperCase()) {
           response[i].val_cat = await this.hashkey.encrypt(response[i].val_cat);
           response[i].cod_img = environment.path_storage+response[i].cod_img;
           this.pasarela.push(response[i]);
          }
        }
      }
      this.membresia = this.membresia.split(',');
      for (const i in this.membresia) {
        this.membresia[i] = this.util.remplazo_especial_restaurar(this.membresia[i]);
      }
      this.b_m = parseFloat(await this.util.numeroFlotante(await this.util.remplazo_coma_punto(this.membresia[2]))) / parseInt(this.membresia[1]) ;
      this.i_m = parseFloat(await this.util.numeroFlotante(await this.util.remplazo_coma_punto(this.membresia[5]))) / parseInt(this.membresia[4]);
      this.p_m = parseFloat(await this.util.numeroFlotante(await this.util.remplazo_coma_punto(this.membresia[8]))) / parseInt(this.membresia[7]);
    } catch (error) {
      console.log(error);
    }
  }
async interval(){
    setTimeout(() => {
      this.secon--;
      if (this.secon < 10) {
        this.seconds.nativeElement.innerText = '0' + this.secon;
      }else{
        this.seconds.nativeElement.innerText = this.secon;
      }
    if(this.secon <= 0){
      this.min--;
      if (this.min >= 0 ) {
        if (this.min < 10) {
          this.minutes.nativeElement.innerText = '0' + this.min;
        }else{
          this.minutes.nativeElement.innerText = this.min;
        }
        this.secon = 59;
        this.interval();
      }else{
        return;
      }
    }else{
      this.interval();
    }
    }, 1000);
    
  }
  async  modalrespuesta(){
    try {
      var accion2 = '';
      var dialogRefp = this.dialog.open(FormmMsgComponent, {
        width: '100vw',
        maxWidth: '100vw',
        height:'auto',
        data: {id:this.data.id_cliente,
              accion:accion2},
        disableClose: true,
        panelClass: 'pedidos_modal',
        backdropClass: "bdrop"
      });
      dialogRefp.afterClosed().subscribe(async result => {
        await this.util.abrirSpinner();
        if(result !== await this.atrb.CERRAR){
            await this.util.cerrarSpinner();
            this.dialogRef.close(await this.atrb.prueba_basica);
        }else{
          await this.util.cerrarSpinner();
        }
      });
    } catch (error) {
      await this.util.cerrarSpinner();
      await this.notifi.customToastNotification(error.error.message);
    }
  }
  async  modalInfo(){
    try {
      var accion2 = '';
      var dialogRefp = this.dialog.open(FormmMsgComponent, {
        width: '100vw',
        maxWidth: '100vw',
        height:'auto',
        data: {id:this.data.id_cliente,
              accion:accion2},
        disableClose: true,
        panelClass: 'pedidos_modal',
        backdropClass: "bdrop"
      });
      dialogRefp.afterClosed().subscribe(async result => {
        await this.util.abrirSpinner();
        if(result !== await this.atrb.CERRAR){
            await this.util.cerrarSpinner();
            this.termino = '2';
        }else{
          await this.util.cerrarSpinner();
        }
      });
    } catch (error) {
      await this.util.cerrarSpinner();
      await this.notifi.customToastNotification(error.error.message);
    }
  }
  async  modalMembresia(){
    try {
      var accion2 = '';
      var dialogRefp = this.dialog.open(FormmMsgComponent, {
        width: '100vw',
        maxWidth: '100vw',
        height:'auto',
        data: {id:this.data.id_cliente,
              accion:accion2},
        disableClose: true,
        panelClass: 'pedidos_modal',
        backdropClass: "bdrop"
      });
      dialogRefp.afterClosed().subscribe(async result => {
        await this.util.abrirSpinner();
        if(result !== await this.atrb.CERRAR){
            await this.util.cerrarSpinner();
            this.termino = '3';
        }else{
          await this.util.cerrarSpinner();
        }
      });
    } catch (error) {
      await this.util.cerrarSpinner();
      await this.notifi.customToastNotification(error.error.message);
    }
  }
  async  modalPay(){
    try {
      var accion2 = '';
      var dialogRefp = this.dialog.open(FormmMsgComponent, {
        width: '100vw',
        maxWidth: '100vw',
        height:'auto',
        data: {id:this.data.id_cliente,
              accion:accion2},
        disableClose: true,
        panelClass: 'pedidos_modal',
        backdropClass: "bdrop"
      });
      dialogRefp.afterClosed().subscribe(async result => {
        await this.util.abrirSpinner();
        if(result !== await this.atrb.CERRAR){
            await this.util.cerrarSpinner();
            this.termino = '2';
        }else{
          await this.util.cerrarSpinner();
        }
      });
    } catch (error) {
      await this.util.cerrarSpinner();
      await this.notifi.customToastNotification(error.error.message);
    }
  }
  async  modalPasarela(xvalor:any,pasarela:any){
    try {
      var accion2 = '';
      var dialogRefp = this.dialog.open(FormmMsgComponent, {
        width: '100vw',
        maxWidth: '100vw',
        height:'auto',
        data: {id:this.data.id_cliente,
              accion:accion2},
        disableClose: true,
        panelClass: 'pedidos_modal',
        backdropClass: "bdrop"
      });
      dialogRefp.afterClosed().subscribe(async result => {
        await this.util.abrirSpinner();
        if(result !== await this.atrb.CERRAR){
          await this.util.cerrarSpinner();
            await this.getPay(xvalor,pasarela);
        }else{
          await this.util.cerrarSpinner();
        }
      });
    } catch (error) {
      await this.util.cerrarSpinner();
      console.log(error);
    }
  }
  async getPay(xvalor,pasarela){
    try {
      await this.getParametrosApp();
      await this.util.abrirSpinner();
      let forma_pago;
      let forma_metodo;
      if (this.pasarela.length <= 0) {
        await this.util.cerrarSpinner();
        await this.notifi.customToastNotification(await this.atrb.MENSAJES_FIJOS.pasarela_vacio_objeto);
        return;
      }
      forma_metodo = pasarela.tipo_cat.split('-');
      for (const i in this.pasarela) {
        console.log(this.pasarela[i]);
            forma_pago = this.pasarela[i].tipo_cat.split('-');
        if (forma_pago[0].toUpperCase() === forma_metodo[0].toUpperCase()) {
              if (this.pasarela[i].estatus.toUpperCase() !== await this.atrb.ACTIVO.toUpperCase()) {
                await this.util.cerrarSpinner();
                await this.notifi.customToastNotification(await this.atrb.MENSAJES_FIJOS.pasarela_msm);
                return;
              }
              if (!this.pasarela[i].val_cat) {
                await this.util.cerrarSpinner();
                await this.notifi.customToastNotification(await this.atrb.MENSAJES_FIJOS.pasarela_vacio);
                return;
              }
              break;
        }else{
          if (this.pasarela.length <= 1) {
                await this.util.cerrarSpinner();
                await this.notifi.customToastNotification(await this.atrb.MENSAJES_FIJOS.pasarela_msm);
                return;
          }
        }
      }
      await this.util.cerrarSpinner();
      let accion = 'salir';
      let dialogRefp = this.dialog.open(FormPasarelaComponent, {
        width: '100vw',
        maxWidth: '100vw',
        height:'auto',
        data: {
              membresia:this.membresia[parseInt(xvalor)],
              pasarela:this.pasarela,
              tipo:forma_metodo[0].toUpperCase(),
              accion:accion
            },
        disableClose: true,
        panelClass: 'pedidos_modal_rep',
        backdropClass: "bdrop"
      });
      dialogRefp.afterClosed().subscribe(async result => {
          await this.util.abrirSpinner();
        if (result.toUpperCase() !== await this.atrb.CERRAR.toUpperCase()) {
          await this.util.cerrarSpinner();
        }else{
          if (result.toUpperCase() === await this.atrb.PROCESO.toUpperCase()) {
            this.dialogRef.close(await this.atrb.CERRAR);
          }
          await this.util.cerrarSpinner();
        }
      });
    } catch (error) {
      await this.util.cerrarSpinner();
      console.log(error);
   }
  }
  async cerrarmodal(){
    try {
      let accion = 'salir';
      let dialogRefp = this.dialog.open(FormmMsgComponent, {
        width: '100vw',
        maxWidth: '100vw',
        height:'auto',
        data: {id:'',
              accion:accion},
        disableClose: true,
        panelClass: 'pedidos_modal',
        backdropClass: "bdrop"
      });
      dialogRefp.afterClosed().subscribe(async result => {
        await this.util.abrirSpinner();
        if (result !== await this.atrb.CERRAR) {
          await this.util.cerrarSpinner();
          this.dialogRef.close(await this.atrb.CERRAR);
        }else{
          await this.util.cerrarSpinner();
        }
      });
    } catch (error) {
      console.log(error);
   }
  }
}
